<po-page-default p-title="Bem vindo(a) ao Portal de Parceiros"
  p-subtitle="Gerencie suas ofertas, produtos, clientes e muito mais em um só lugar.">
</po-page-default>